// @flow
/* eslint max-len: [2, 120] */

import React from 'react';
import MediaQuery, { useMediaQuery } from 'react-responsive';
import theme from '../../theme';

type Props = {
  children?: any,
  desktop?: boolean,
  desktopAndUp?: boolean,
  desktopLarge?: boolean,
  mobile?: boolean,
  tablet?: boolean,
  tabletPortrait?: boolean,
  tabletLandscape?: boolean,
  mobilePortrait?: boolean,
  mobileLandscape?: boolean
};

const defaultProps = {
  children: undefined,
  desktop: undefined,
  desktopAndUp: undefined,
  desktopLarge: undefined,
  mobile: undefined,
  tablet: undefined,
  tabletPortrait: undefined,
  tabletLandscape: undefined,
  mobilePortrait: undefined,
  mobileLandscape: undefined
};

function Responsive({
  children,
  desktop,
  desktopAndUp,
  desktopLarge,
  mobile,
  mobilePortrait,
  mobileLandscape,
  tablet,
  tabletLandscape,
  tabletPortrait
}: Props) {
  const showTabletPortrait = !!tabletPortrait || (tabletPortrait === undefined && mobile);
  const showTabletLandscape =
    !!tabletLandscape || (tabletLandscape === undefined && showTabletPortrait);
  const showDesktopLarge = !!desktopLarge || (desktopLarge === undefined && desktop);

  const queries = [];
  if (mobile) {
    queries.push(theme.mediaQuery.mobileOnly);
  }
  if (mobilePortrait) {
    queries.push(theme.mediaQuery.mobilePortraitOnly);
  }
  if (mobileLandscape) {
    queries.push(theme.mediaQuery.mobileLandscapeOnly);
  }
  if (tablet) {
    queries.push(theme.mediaQuery.tabletPortraitAndBelow);
  }
  if (showTabletPortrait) {
    queries.push(theme.mediaQuery.tabletPortraitOnly);
  }
  if (showTabletLandscape) {
    queries.push(theme.mediaQuery.tabletLandscapeOnly);
  }
  if (desktop) {
    queries.push(theme.mediaQuery.desktopOnly);
  }
  if (desktopAndUp) {
    queries.push(theme.mediaQuery.desktopAndUp);
  }
  if (showDesktopLarge) {
    queries.push(theme.mediaQuery.desktopLargeOnly);
  }

  if (queries.length === 0) {
    return null;
  }

  const query = queries.map(q => q.replace('@media ', '')).join(', ');
  return <MediaQuery query={query}>{children}</MediaQuery>;
}
Responsive.defaultProps = defaultProps;

export default Responsive;

export const useIsMobile = () => {
  return useMediaQuery({ query: '(max-width: 1024px)' });
};
